'use client';

// BetaNotice — a slim, dismissible "we're in beta / actively improving" banner.
// Rendered IN-FLOW at the top of the page content (not a floating overlay), so it
// never covers buttons or CTAs. Dismissal is remembered per browser. The text is
// plain (no data-no-i18n) so the runtime translation layer localizes it too.

import { useState, useEffect } from 'react';

export default function BetaNotice() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        let alive = true;
        // Owner-only: the product owner's OWN install shows the beta notice. A rebranded
        // CLIENT build (no owner-keys.json => tier !== 'owner') never sees it. If the
        // license check can't be read, default to HIDDEN (safe for client builds).
        fetch('/api/license/status').then(r => r.json()).then(d => {
            if (!alive) return;
            if (!(d && d.success && d.tier === 'owner')) { setShow(false); return; }
            try { setShow(localStorage.getItem('betaNoticeDismissed') !== '1'); }
            catch { setShow(true); }
        }).catch(() => { if (alive) setShow(false); });
        return () => { alive = false; };
    }, []);

    if (!show) return null;

    return (
        <div style={{
            margin: '0 0 20px', padding: '12px 16px', borderRadius: '12px',
            background: '#e8f0fe', border: '1px solid #d2e3fc', borderLeft: '4px solid #2563eb',
            display: 'flex', alignItems: 'center', gap: '12px', fontSize: '13.5px', color: '#174ea6',
        }}>
            <span style={{ fontWeight: 800, letterSpacing: '0.05em', background: '#2563eb', color: '#ffffff', padding: '3px 9px', borderRadius: '6px', whiteSpace: 'nowrap', flexShrink: 0, fontSize: '12px' }}>🧪 BETA</span>
            <span style={{ flex: 1, lineHeight: 1.55, fontWeight: 500 }}>
                This software is in active development — we&apos;re continuously updating and improving it. If you run into a bug or something isn&apos;t perfect yet, thanks for your patience: fixes and new features ship regularly.
            </span>
            <button
                onClick={() => { try { localStorage.setItem('betaNoticeDismissed', '1'); } catch {} setShow(false); }}
                title="Dismiss"
                style={{ flexShrink: 0, background: '#ffffff', border: '1px solid #d2e3fc', color: '#2563eb', cursor: 'pointer', fontSize: '15px', lineHeight: 1, padding: '4px 9px', borderRadius: '8px', fontWeight: 700 }}
            >
                ✕
            </button>
        </div>
    );
}
